module.exports = __webpack_public_path__ + "img/top_hero.4bd24726.jpg";